import { type ServiceError } from 'gpcore-apikit/grpc/types';
import { useImageStore } from 'gpcore-apikit/store/pinia/image';
import { useProjectStore } from 'gpcore-apikit/store/pinia/project';
import useNotifications from 'gpcore-uikit/composables/useNotifications';
import { ref } from 'vue';

export default () => {
  const imageStore = useImageStore();
  const projectStore = useProjectStore();
  const { addNotification } = useNotifications();
  const toDeleteVersionId = ref<string>();
  const isDeleteVersionModalOpened = ref(false);
  const isDeletingVersion = ref(false);

  const onDeleteVersion = (versionId: string) => {
    toDeleteVersionId.value = versionId;
    isDeleteVersionModalOpened.value = true;
  };

  const deleteVersion = async () => {
    isDeletingVersion.value = true;
    try {
      await imageStore.deleteImageVersion(projectStore.projectId, toDeleteVersionId.value);
      isDeleteVersionModalOpened.value = false;
      toDeleteVersionId.value = null;

      addNotification({
        type: 'success',
        message: 'Version has been deleted.',
      });
    } catch (error) {
      addNotification({
        type: 'danger',
        message: (error as ServiceError).message,
      });
    } finally {
      isDeletingVersion.value = false;
    }
  };

  return {
    toDeleteVersionId,
    isDeleteVersionModalOpened,
    isDeletingVersion,
    onDeleteVersion,
    deleteVersion,
  };
};
